import { connect } from 'react-redux';
import get from 'lodash.get';
import * as ReturnDetailsActions from '../../../../store/returns/details/returns.details.actions';
import * as ReturnActions from '../../../../store/returns/returns.actions';
import { OtherActions } from './other-actions';
import { OtherActionsButton } from './other-actions-button';

const mapDispatchToProps = (dispatch, ownProps) => {
  const fulfillmentId = get(ownProps, 'returnShipment.fulfillmentId');
  const returnShipment = get(ownProps, 'returnShipment');
  return {
    markAsReceived: () => dispatch(ReturnDetailsActions.openSetReceivedDateModal(fulfillmentId)),
    updateReceivedDate: () => dispatch(ReturnDetailsActions.openUpdateReceivedDateModal(fulfillmentId)),
    voidAndCancel: () => dispatch(ReturnActions.openCancelReturnLabelModal([fulfillmentId], false)),
    sendReturnLabel: () => dispatch(ReturnActions.openEmailReturnLabelModal([returnShipment])),
    downloadReturnLabel: () => dispatch(ReturnActions.downloadReturnLabel(fulfillmentId)),
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { returnShipment } = ownProps;
  const filteredOtherActions = OtherActions.filter((action) => action.shouldBeShown(returnShipment));
  const actions = filteredOtherActions.map((action) => ({
    ...action,
    handler: () => action.handler(dispatchProps),
  }));
  return {
    actions,
  };
};

export const OtherActionsButtonContainer = connect(undefined, mapDispatchToProps, mergeProps)(OtherActionsButton);
